import styled from "styled-components";

export const QuestionStyled = styled.div`
  display: flex;
  column-gap: 12px;
  cursor: pointer;
  .figture_img {
    position: relative;
    flex-shrink: 0;
    flex-basis: 140px;
    .status_line {
      position: absolute;
      bottom: 0px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .activity_news_detail {
    width: 100%;
    .activity_news_title_bar {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      column-gap: 10px;
      &:hover {
        .activity_news_title {
          color: ${({ theme }) => theme.COLORS.PURPLE_10};
        }
        .arrow_button {
          svg {
            circle {
              stroke: ${({ theme }) => theme.COLORS.PURPLE_10};
            }
            path {
              fill: ${({ theme }) => theme.COLORS.PURPLE_10};
            }
          }
        }
      }
      .activity_news_title {
        color: ${({ theme }) => theme.COLORS.BLACK_3};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      }
      .arrow_button {
        background: none;
        cursor: pointer;
      }
    }
    .activity_news_subtitle {
      color: ${({ theme }) => theme.COLORS.GRAY_12};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.IPAD}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    .activity_news_detail {
      .activity_news_title_bar {
        margin-bottom: 2px;
        line-height: 1.2;
        .arrow_button {
          display: none;
        }
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    .figture_img {
      width: 100px;
      height: 100px;
      flex-basis: 100px;
    }
    .activity_news_detail {
      .activity_news_title_bar {
        .arrow_button {
          display: none;
        }
      }
    }
  }
`;
